module.exports = __webpack_public_path__ + "static/img/jd8.e55da8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd8.jpg
// module id = XK2l
// module chunks = 1